import { Component, Prop, h, Host, State } from '@stencil/core';
import _ from 'lodash'
import '../header-component/header-component';
import '../loader-component/loader-component'
/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/documents-component.PNG)

#### Content Type
Document
*/


@Component({
  tag: 'documents-component',
  styleUrl: 'documents-component.css',
  // shadow: true,
  scoped: true
})
export class DocumentsComponent {

  /**
   *Required - Unique ID.
   */
   @Prop() componentid: string = "comp-id";

   /**
   *Required - List Name.
   */
   @Prop() listname: string = "ListName";
 
   /**
   *Required - Relative to the root site. no trailing slash for ex: /hr/pm
   */
   @Prop() webpath: string = "/";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() sectiontitle: string = "Section Title";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() titleiconurl: string = "";
 
    /**
   *Optional - To show/hide header - default is true
   */
  @Prop() header: boolean = true;
 
   /**
  *Optional - vertical scroll bar
  */
   @Prop() verticalscroll: boolean = false;
 
   /**
  *Optional - vertical scroll bar height
  */
   @Prop() verticalscrollheight: number = 200;

  /**
  *Optional - number of items
  */
  @Prop() count: number =100;


   /**
*Optional - header background color
*/
@Prop() headerbgcolor: string ="white"

/**
*Optional -header text color
*/
@Prop() headertextcolor: string = "black"
/**
*Optional -header border bottom css
*/
@Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
 *Optional - To show see All link
 */
 @Prop() seeall: boolean = false;
 /**
*Optional - see All link
*/
 @Prop() seeallurl: string="";

    /**
*Optional - see All link Title
*/
@Prop() seealltitle: string = "See All";
  /**
*Optional - is it SP Online site
*/
@Prop() online:boolean=false;
 /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";

  /**
   *optional - sorty by. possible values 'modified,Title,ItemOrder'
   */
   @Prop() sortby: string = "Modified";


    
  @State() items: [];
  @State() isLoading: boolean = true;
  

  componentWillLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    // let siteUrl:string="";
    
    // if (this.online) {
    //   siteUrl=this.siteurl+this.webpath 
    // }
    // else
    // {
    //   siteUrl=(window as any)._spPageContextInfo.siteAbsoluteUrl+this.webpath ;
    // }

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }
   

    // return fetch(siteUrl  + "/_api/web/GetFolderByServerRelativeUrl('" + this.webpath + "/" + this.listname + "')/Files?$select=ID,Name,Title,nypwebc_ItemOrder&$top=" + this.count + "&$orderby=TimeLastModified desc", { headers: { "Accept": "application/json; odata=verbose" } })

    // return fetch(siteUrl + "/_api/web/GetFolderByServerRelativeUrl('" + this.webpath + "/" + this.listname + "')?$expand=Files/ListItemAllFields&$top=" + this.count + "&$filter=" + filter, config)
    return fetch(siteUrl  + "/_api/web/GetFolderByServerRelativeUrl('" + this.webpath + "/" + this.listname + "')?$expand=Files/ListItemAllFields&$top=" + this.count + "&$orderby=TimeLastModified desc", { headers: { "Accept": "application/json; odata=verbose" } })
    
      .then(response => response.json())
      .then(data => {
        this.items = data.d.Files.results;
        this.isLoading=false;
      });
  }

  getContents = () => {
    const contentsArray = []
    let myData: any = {}
   
    if (this.sortby === 'ItemOrder')
    {
      //myData = this.items.sort((a: any, b: any) => a.ListItemAllFields.nypwebc_ItemOrder > b.ListItemAllFields.nypwebc_ItemOrder ? 1 : -1)

      myData = _.orderBy(this.items, ['ListItemAllFields.nypwebc_ItemOrder'], ['asc']);

    }
    else if (this.sortby === 'Title')
    {
      myData = _.orderBy(this.items, ['ListItemAllFields.Title'], ['asc']);

    }
    else 
    {
      myData = _.orderBy(this.items, ['ListItemAllFields.Modified'], ['desc']);

    }
   
    
    myData.forEach((item: any) => {

      let itemUrl = this.webpath + "/" + this.listname + "/" + item.Name + "?Web=1"
      let title = ""
      if (item.Title) {
        title = item.Title
      }
      else {
        title = item.Name
      }

      contentsArray.push(
        <li class="list-group-item"> <a href={itemUrl} target= "_blank"  data-interception="off" >{title}</a></li>
      )

    })
    return contentsArray
  }

  render() {

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle  = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
            }
    }

    return (
      this.isLoading?
      
      <loader-component />

      :
      this.header  && this.items.length > 0 ?
        <div>
         
             <header-component   sectiontitle={this.sectiontitle}   titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle= {this.seealltitle} seeallurl={this.seeallurl}  headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
          <div class="row gx-0" style={parentstyle} >
            <div  style={styleWithHeader}>
              <ul class="list-group list-group-flush" >
                {this.getContents()}
              </ul>
            </div>
          </div>
        </div>
        :
        <div class="row gx-0" style={parentstyle} >
          <div  style={style}>
            <ul class="list-group list-group-flush" >
              {this.getContents()}
            </ul>
          </div>
        </div>


    )

  }

}
